// extracted by mini-css-extract-plugin
export default {"option":"option_option__sm5sg","active":"option_active__vAj2P","inactive":"option_inactive__A0z9w"};